/* Generated by `npm run marketing:asset:push` — do not edit by hand. */
export const mediaManifest = {
  "Claude_add_connector.webp": {
    "key": "assets/Claude_add_connector-73c7824d.webp",
    "contentType": "image/webp",
    "bytes": 46042
  },
  "Claude_connector_signin.webp": {
    "key": "assets/Claude_connector_signin-8ce28afa.webp",
    "contentType": "image/webp",
    "bytes": 81984
  },
  "Claude_custom_connector.webp": {
    "key": "assets/Claude_custom_connector-a639db4a.webp",
    "contentType": "image/webp",
    "bytes": 68330
  },
  "agent-desktop-demo-light-cc.mp4": {
    "key": "assets/agent-desktop-demo-light-cc-0c2efe8b.mp4",
    "contentType": "video/mp4",
    "bytes": 2976876
  },
  "agent-desktop-demo-light-poster.webp": {
    "key": "assets/agent-desktop-demo-light-poster-5d9b5fb8.webp",
    "contentType": "image/webp",
    "bytes": 102274
  },
  "approval-status-software-dark-1280.webp": {
    "key": "assets/approval-status-software-dark-1280-0193bfc2.webp",
    "contentType": "image/webp",
    "bytes": 75886
  },
  "approval-status-software-dark-640.webp": {
    "key": "assets/approval-status-software-dark-640-fe5a6415.webp",
    "contentType": "image/webp",
    "bytes": 40796
  },
  "approval-status-software-dark-960.webp": {
    "key": "assets/approval-status-software-dark-960-7b650f0c.webp",
    "contentType": "image/webp",
    "bytes": 57564
  },
  "approval-status-software-light-1280.webp": {
    "key": "assets/approval-status-software-light-1280-c5945384.webp",
    "contentType": "image/webp",
    "bytes": 84186
  },
  "approval-status-software-light-640.webp": {
    "key": "assets/approval-status-software-light-640-999c6785.webp",
    "contentType": "image/webp",
    "bytes": 44884
  },
  "approval-status-software-light-960.webp": {
    "key": "assets/approval-status-software-light-960-9283453f.webp",
    "contentType": "image/webp",
    "bytes": 64492
  },
  "changes-software-dark-1280.webp": {
    "key": "assets/changes-software-dark-1280-bc69bea8.webp",
    "contentType": "image/webp",
    "bytes": 52850
  },
  "changes-software-dark-640.webp": {
    "key": "assets/changes-software-dark-640-ca861ddb.webp",
    "contentType": "image/webp",
    "bytes": 21412
  },
  "changes-software-dark-960.webp": {
    "key": "assets/changes-software-dark-960-ccba0966.webp",
    "contentType": "image/webp",
    "bytes": 37444
  },
  "changes-software-light-1280.webp": {
    "key": "assets/changes-software-light-1280-6e6c38b6.webp",
    "contentType": "image/webp",
    "bytes": 54668
  },
  "changes-software-light-640.webp": {
    "key": "assets/changes-software-light-640-55011b42.webp",
    "contentType": "image/webp",
    "bytes": 21940
  },
  "changes-software-light-960.webp": {
    "key": "assets/changes-software-light-960-b119527a.webp",
    "contentType": "image/webp",
    "bytes": 38486
  },
  "chatgpt_desktop_mcp.webp": {
    "key": "assets/chatgpt_desktop_mcp-2e266f09.webp",
    "contentType": "image/webp",
    "bytes": 48168
  },
  "chatgpt_mcp_add.webp": {
    "key": "assets/chatgpt_mcp_add-e915df96.webp",
    "contentType": "image/webp",
    "bytes": 21762
  },
  "chatgpt_mcp_config.webp": {
    "key": "assets/chatgpt_mcp_config-dd6d4ab9.webp",
    "contentType": "image/webp",
    "bytes": 62588
  },
  "documents-software-dark-1280.webp": {
    "key": "assets/documents-software-dark-1280-068c8842.webp",
    "contentType": "image/webp",
    "bytes": 14938
  },
  "documents-software-dark-1920.webp": {
    "key": "assets/documents-software-dark-1920-e67e9056.webp",
    "contentType": "image/webp",
    "bytes": 26528
  },
  "documents-software-dark-640.webp": {
    "key": "assets/documents-software-dark-640-fcd25d20.webp",
    "contentType": "image/webp",
    "bytes": 4888
  },
  "documents-software-dark-960.webp": {
    "key": "assets/documents-software-dark-960-f1c89ad1.webp",
    "contentType": "image/webp",
    "bytes": 9742
  },
  "documents-software-light-1280.webp": {
    "key": "assets/documents-software-light-1280-716970fa.webp",
    "contentType": "image/webp",
    "bytes": 15444
  },
  "documents-software-light-1920.webp": {
    "key": "assets/documents-software-light-1920-042772a7.webp",
    "contentType": "image/webp",
    "bytes": 27858
  },
  "documents-software-light-640.webp": {
    "key": "assets/documents-software-light-640-d0b9624a.webp",
    "contentType": "image/webp",
    "bytes": 5096
  },
  "documents-software-light-960.webp": {
    "key": "assets/documents-software-light-960-2279fccc.webp",
    "contentType": "image/webp",
    "bytes": 10366
  },
  "edit-outline-software-dark-1280.webp": {
    "key": "assets/edit-outline-software-dark-1280-9aab15fa.webp",
    "contentType": "image/webp",
    "bytes": 61386
  },
  "edit-outline-software-dark-640.webp": {
    "key": "assets/edit-outline-software-dark-640-7059cfe8.webp",
    "contentType": "image/webp",
    "bytes": 25668
  },
  "edit-outline-software-dark-960.webp": {
    "key": "assets/edit-outline-software-dark-960-bea2d05d.webp",
    "contentType": "image/webp",
    "bytes": 44066
  },
  "edit-outline-software-light-1280.webp": {
    "key": "assets/edit-outline-software-light-1280-2b6e09f2.webp",
    "contentType": "image/webp",
    "bytes": 65010
  },
  "edit-outline-software-light-640.webp": {
    "key": "assets/edit-outline-software-light-640-240d51e8.webp",
    "contentType": "image/webp",
    "bytes": 26866
  },
  "edit-outline-software-light-960.webp": {
    "key": "assets/edit-outline-software-light-960-77e92f8b.webp",
    "contentType": "image/webp",
    "bytes": 46672
  },
  "lead-gen-banner-software-dark.png": {
    "key": "assets/lead-gen-banner-software-dark-684baff0.png",
    "contentType": "image/png",
    "bytes": 59496
  },
  "lead-gen-banner-software-light.png": {
    "key": "assets/lead-gen-banner-software-light-7b134539.png",
    "contentType": "image/png",
    "bytes": 61854
  },
  "marketing-overview-software-dark-cc.mp4": {
    "key": "assets/marketing-overview-software-dark-cc-302ecc1e.mp4",
    "contentType": "video/mp4",
    "bytes": 4621353
  },
  "marketing-overview-software-dark-poster.webp": {
    "key": "assets/marketing-overview-software-dark-poster-5654f19c.webp",
    "contentType": "image/webp",
    "bytes": 34570
  },
  "marketing-overview-software-dark.mp4": {
    "key": "assets/marketing-overview-software-dark-e3646fb3.mp4",
    "contentType": "video/mp4",
    "bytes": 5468196
  },
  "marketing-overview-software-dark.srt": {
    "key": "assets/marketing-overview-software-dark-07e92fc1.srt",
    "contentType": "application/x-subrip",
    "bytes": 509
  },
  "marketing-overview-software-dark.vtt": {
    "key": "assets/marketing-overview-software-dark-6d8c5c25.vtt",
    "contentType": "text/vtt",
    "bytes": 505
  },
  "marketing-overview-software-light-cc.mp4": {
    "key": "assets/marketing-overview-software-light-cc-6c448046.mp4",
    "contentType": "video/mp4",
    "bytes": 4488898
  },
  "marketing-overview-software-light-poster.webp": {
    "key": "assets/marketing-overview-software-light-poster-18488fd4.webp",
    "contentType": "image/webp",
    "bytes": 35596
  },
  "marketing-overview-software-light.mp4": {
    "key": "assets/marketing-overview-software-light-3dfa2c8e.mp4",
    "contentType": "video/mp4",
    "bytes": 5159131
  },
  "marketing-overview-software-light.srt": {
    "key": "assets/marketing-overview-software-light-07e92fc1.srt",
    "contentType": "application/x-subrip",
    "bytes": 509
  },
  "marketing-overview-software-light.vtt": {
    "key": "assets/marketing-overview-software-light-6d8c5c25.vtt",
    "contentType": "text/vtt",
    "bytes": 505
  },
  "mcp-app-demo-light-cc.mp4": {
    "key": "assets/mcp-app-demo-light-cc-99bc3887.mp4",
    "contentType": "video/mp4",
    "bytes": 3689658
  },
  "mcp-app-demo-light-poster.webp": {
    "key": "assets/mcp-app-demo-light-poster-90364c86.webp",
    "contentType": "image/webp",
    "bytes": 34788
  },
  "overview-approval-rules-software-dark-cc.mp4": {
    "key": "assets/overview-approval-rules-software-dark-cc-ae756db8.mp4",
    "contentType": "video/mp4",
    "bytes": 5769298
  },
  "overview-approval-rules-software-dark-poster.webp": {
    "key": "assets/overview-approval-rules-software-dark-poster-1c66637a.webp",
    "contentType": "image/webp",
    "bytes": 50430
  },
  "overview-approval-rules-software-dark.mp4": {
    "key": "assets/overview-approval-rules-software-dark-767fb40a.mp4",
    "contentType": "video/mp4",
    "bytes": 3996952
  },
  "overview-approval-rules-software-dark.srt": {
    "key": "assets/overview-approval-rules-software-dark-2da797cc.srt",
    "contentType": "application/x-subrip",
    "bytes": 1281
  },
  "overview-approval-rules-software-dark.vtt": {
    "key": "assets/overview-approval-rules-software-dark-2a819f48.vtt",
    "contentType": "text/vtt",
    "bytes": 1250
  },
  "overview-approval-rules-software-light-cc.mp4": {
    "key": "assets/overview-approval-rules-software-light-cc-dc95801d.mp4",
    "contentType": "video/mp4",
    "bytes": 5666759
  },
  "overview-approval-rules-software-light-poster.webp": {
    "key": "assets/overview-approval-rules-software-light-poster-8ac6796f.webp",
    "contentType": "image/webp",
    "bytes": 52658
  },
  "overview-approval-rules-software-light.mp4": {
    "key": "assets/overview-approval-rules-software-light-90bcabe3.mp4",
    "contentType": "video/mp4",
    "bytes": 4371269
  },
  "overview-approval-rules-software-light.srt": {
    "key": "assets/overview-approval-rules-software-light-9ca6a5cf.srt",
    "contentType": "application/x-subrip",
    "bytes": 1281
  },
  "overview-approval-rules-software-light.vtt": {
    "key": "assets/overview-approval-rules-software-light-08919bba.vtt",
    "contentType": "text/vtt",
    "bytes": 1250
  },
  "overview-change-management-software-dark-cc.mp4": {
    "key": "assets/overview-change-management-software-dark-cc-7763123f.mp4",
    "contentType": "video/mp4",
    "bytes": 21980003
  },
  "overview-change-management-software-dark-poster.webp": {
    "key": "assets/overview-change-management-software-dark-poster-b04929c6.webp",
    "contentType": "image/webp",
    "bytes": 49588
  },
  "overview-change-management-software-dark.srt": {
    "key": "assets/overview-change-management-software-dark-6f952d49.srt",
    "contentType": "application/x-subrip",
    "bytes": 2085
  },
  "overview-change-management-software-dark.vtt": {
    "key": "assets/overview-change-management-software-dark-efc8c0e1.vtt",
    "contentType": "text/vtt",
    "bytes": 2024
  },
  "overview-change-management-software-light-cc.mp4": {
    "key": "assets/overview-change-management-software-light-cc-e766845e.mp4",
    "contentType": "video/mp4",
    "bytes": 18993551
  },
  "overview-change-management-software-light-poster.webp": {
    "key": "assets/overview-change-management-software-light-poster-e291da78.webp",
    "contentType": "image/webp",
    "bytes": 51962
  },
  "overview-change-management-software-light.srt": {
    "key": "assets/overview-change-management-software-light-d997efbc.srt",
    "contentType": "application/x-subrip",
    "bytes": 2085
  },
  "overview-change-management-software-light.vtt": {
    "key": "assets/overview-change-management-software-light-5e4782ab.vtt",
    "contentType": "text/vtt",
    "bytes": 2024
  },
  "overview-details-software-dark-cc.mp4": {
    "key": "assets/overview-details-software-dark-cc-6020d2f8.mp4",
    "contentType": "video/mp4",
    "bytes": 12505160
  },
  "overview-details-software-dark.srt": {
    "key": "assets/overview-details-software-dark-df501f10.srt",
    "contentType": "application/x-subrip",
    "bytes": 1393
  },
  "overview-details-software-dark.vtt": {
    "key": "assets/overview-details-software-dark-5f50e2b0.vtt",
    "contentType": "text/vtt",
    "bytes": 1359
  },
  "overview-details-software-light-cc.mp4": {
    "key": "assets/overview-details-software-light-cc-799f9356.mp4",
    "contentType": "video/mp4",
    "bytes": 12035614
  },
  "overview-details-software-light.srt": {
    "key": "assets/overview-details-software-light-df501f10.srt",
    "contentType": "application/x-subrip",
    "bytes": 1393
  },
  "overview-details-software-light.vtt": {
    "key": "assets/overview-details-software-light-5f50e2b0.vtt",
    "contentType": "text/vtt",
    "bytes": 1359
  },
  "overview-teams-software-dark-cc.mp4": {
    "key": "assets/overview-teams-software-dark-cc-9529ce28.mp4",
    "contentType": "video/mp4",
    "bytes": 4092258
  },
  "overview-teams-software-dark-poster.webp": {
    "key": "assets/overview-teams-software-dark-poster-66f8f9d6.webp",
    "contentType": "image/webp",
    "bytes": 13754
  },
  "overview-teams-software-dark.srt": {
    "key": "assets/overview-teams-software-dark-a8b1ff6f.srt",
    "contentType": "application/x-subrip",
    "bytes": 1734
  },
  "overview-teams-software-dark.vtt": {
    "key": "assets/overview-teams-software-dark-e94ed83a.vtt",
    "contentType": "text/vtt",
    "bytes": 1688
  },
  "overview-teams-software-light-cc.mp4": {
    "key": "assets/overview-teams-software-light-cc-bb82b122.mp4",
    "contentType": "video/mp4",
    "bytes": 4120002
  },
  "overview-teams-software-light-poster.webp": {
    "key": "assets/overview-teams-software-light-poster-99b2beb9.webp",
    "contentType": "image/webp",
    "bytes": 14204
  },
  "overview-teams-software-light.srt": {
    "key": "assets/overview-teams-software-light-a8b1ff6f.srt",
    "contentType": "application/x-subrip",
    "bytes": 1734
  },
  "overview-teams-software-light.vtt": {
    "key": "assets/overview-teams-software-light-e94ed83a.vtt",
    "contentType": "text/vtt",
    "bytes": 1688
  },
  "positioning-slide-goalie-software-dark.png": {
    "key": "assets/positioning-slide-goalie-software-dark-6abfcf76.png",
    "contentType": "image/png",
    "bytes": 231992
  },
  "positioning-slide-goalie-software-light.png": {
    "key": "assets/positioning-slide-goalie-software-light-c473e8ac.png",
    "contentType": "image/png",
    "bytes": 233967
  },
  "positioning-slide-software-dark.png": {
    "key": "assets/positioning-slide-software-dark-a79f564d.png",
    "contentType": "image/png",
    "bytes": 232493
  },
  "positioning-slide-software-light.png": {
    "key": "assets/positioning-slide-software-light-7c34840b.png",
    "contentType": "image/png",
    "bytes": 233657
  },
  "product-demo-software-light-cc.mp4": {
    "key": "assets/product-demo-software-light-cc-46a70318.mp4",
    "contentType": "video/mp4",
    "bytes": 74396065
  },
  "product-demo-software-light-poster.webp": {
    "key": "assets/product-demo-software-light-poster-e291da78.webp",
    "contentType": "image/webp",
    "bytes": 51962
  },
  "product-demo-software-light.srt": {
    "key": "assets/product-demo-software-light-a8342e3f.srt",
    "contentType": "application/x-subrip",
    "bytes": 14354
  },
  "product-demo-software-light.vtt": {
    "key": "assets/product-demo-software-light-238dee7a.vtt",
    "contentType": "text/vtt",
    "bytes": 13746
  },
  "projects-software-dark-1280.webp": {
    "key": "assets/projects-software-dark-1280-db8d2853.webp",
    "contentType": "image/webp",
    "bytes": 14756
  },
  "projects-software-dark-1920.webp": {
    "key": "assets/projects-software-dark-1920-88c62222.webp",
    "contentType": "image/webp",
    "bytes": 26124
  },
  "projects-software-dark-640.webp": {
    "key": "assets/projects-software-dark-640-fd94c0cc.webp",
    "contentType": "image/webp",
    "bytes": 4824
  },
  "projects-software-dark-960.webp": {
    "key": "assets/projects-software-dark-960-e7a4f0be.webp",
    "contentType": "image/webp",
    "bytes": 9578
  },
  "projects-software-light-1280.webp": {
    "key": "assets/projects-software-light-1280-bbabe3b5.webp",
    "contentType": "image/webp",
    "bytes": 15302
  },
  "projects-software-light-1920.webp": {
    "key": "assets/projects-software-light-1920-1c84038b.webp",
    "contentType": "image/webp",
    "bytes": 27500
  },
  "projects-software-light-640.webp": {
    "key": "assets/projects-software-light-640-9ea78949.webp",
    "contentType": "image/webp",
    "bytes": 4984
  },
  "projects-software-light-960.webp": {
    "key": "assets/projects-software-light-960-6d0751c7.webp",
    "contentType": "image/webp",
    "bytes": 10186
  },
  "social-ad-software-dark.png": {
    "key": "assets/social-ad-software-dark-bdc98b5d.png",
    "contentType": "image/png",
    "bytes": 147082
  },
  "social-ad-software-light.png": {
    "key": "assets/social-ad-software-light-f1c88755.png",
    "contentType": "image/png",
    "bytes": 154585
  },
  "social-ad-square-software-dark.png": {
    "key": "assets/social-ad-square-software-dark-d5f71b98.png",
    "contentType": "image/png",
    "bytes": 176544
  },
  "social-ad-square-software-light.png": {
    "key": "assets/social-ad-square-software-light-756662e9.png",
    "contentType": "image/png",
    "bytes": 184720
  },
  "spec-software-dark-1280.webp": {
    "key": "assets/spec-software-dark-1280-e1eaae68.webp",
    "contentType": "image/webp",
    "bytes": 115176
  },
  "spec-software-dark-640.webp": {
    "key": "assets/spec-software-dark-640-c3e9e72e.webp",
    "contentType": "image/webp",
    "bytes": 45240
  },
  "spec-software-dark-960.webp": {
    "key": "assets/spec-software-dark-960-ac7395a7.webp",
    "contentType": "image/webp",
    "bytes": 82188
  },
  "spec-software-light-1280.webp": {
    "key": "assets/spec-software-light-1280-62d37d3f.webp",
    "contentType": "image/webp",
    "bytes": 122426
  },
  "spec-software-light-640.webp": {
    "key": "assets/spec-software-light-640-079cb85e.webp",
    "contentType": "image/webp",
    "bytes": 47876
  },
  "spec-software-light-960.webp": {
    "key": "assets/spec-software-light-960-54a6dc68.webp",
    "contentType": "image/webp",
    "bytes": 86744
  }
};
